export default __webpack_public_path__ + "images/8b298d55d619a41f0b02c5dd2f72580b.png";